<template>
  <el-dialog
    append-to-body
    width="600px"
    title="工资发放审批"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      element-loading-text="加载中…"
      ref="elFormDom"
      :model="info"
      :rules="rules"
      v-loading="loading"
      label-width="130px"
      label-position="right"
      :size="subUnitSize"
    >
      <el-form-item label="工资审批单号：" v-if="info && info.used_oa_approval_no">
        {{ info.used_oa_approval_no }}
      </el-form-item>
      <el-form-item prop="invoice_company_name" label="付款单位：">
        <el-input v-model="info.invoice_company_name" disabled></el-input>
      </el-form-item>
      <el-form-item prop="fees" label="费用明细：">
        <el-input
          type="textarea"
          :rows="6"
          placeholder="请输入内容"
          v-model="info.fees"
          disabled
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="total_salary" label="实发金额：">
        <el-input v-model="info.total_salary" disabled></el-input>
        <!-- <div>{{ calc.convertToUpperCase(info.total_salary) }}</div> -->
        <div>{{ info.chinese_total_salery }}</div>
      </el-form-item>
      <el-form-item prop="issued_day" label="发放日期：">
        <el-date-picker
          :disabled="Boolean(detailId)"
          v-model="info.issued_day"
          type="date"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="files" label="附件：">
        <div 
          v-for="(item, index) in info.files"
          :key="index">
          <el-link
            type="primary"
            @click="hadlePreview(item)"
            >{{ item.name }}</el-link>
          <el-popover
            :ref="`popoverDom+${index}`"
            placement="top"
            width="400"
            @show="handlePopover(item, index)"
            trigger="click"
          >
            <el-form class="staff-from" :model="form.data">
              <el-form-item label="修改文件名" prop="sort">
                <el-input v-model="form.data.name" clearable>
                  <template slot="append">.xlsx</template>
                </el-input>
              </el-form-item>
            </el-form>
            <el-row type="flex" justify="center">
              <el-button
                type="primary"
                :loading="form.loading"
                :disabled="form.loading"
                @click="handleSaveName(item, index)"
                >确定</el-button
              >
            </el-row>
            <el-button slot="reference" type="text" style="margin-left:20px">编辑</el-button>
          </el-popover>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button type="primary" @click="confirm" v-if="!detailId">提交OA流程</el-button>
        <el-button @click="toggle(false)">关闭</el-button>
      </el-row>
    </template>
    <inputOaDialog ref="inputOaDialogRef" @success="oaSuccess"></inputOaDialog>
    <VueOfficeView ref="fileView" :fileType="fileType" :fileUrl="fileUrl" :fileName="fileName"></VueOfficeView>
  </el-dialog>
</template>

<script>
import VueOfficeView from '@/components/VueOfficeView.vue'
import inputOaDialog from "./inputOaDialog.vue";
import calc from "@/util/calc";
export default {
  components: { inputOaDialog,VueOfficeView },
  data() {
    return {
      calc,
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      info: {
        issued_day: "",
        files: [],
        chinese_total_salery: "",
        invoice_company_name: "",
        fees: "",
      },
      rules: {
        issued_day: [{ required: true, message: "必填", trigger: "change" }],
      },
      detailId:'',
      fileUrl:'',
      fileName:'',
      fileType:5,
      form:{
        loading:false,
        data:{
          name:'',
        }
      }
    };
  },
  methods: {
    handlePopover(item) {
      this.form.data.name = item.name.replace(/\.[^/.]+$/, '');;
    },
    handleSaveName(item,index) {
      if(!this.form.data.name){
        this.$message.error('文件名不能为空');
        return;
      }
      item.name = this.form.data.name + '.xlsx';
      const refName = `popoverDom+${index}`; // 这里必须带 + 号
      const popover = this.$refs[refName][0];
      if (popover) {
        popover.doClose(); // Vue2 ElementUI 关闭方法
      } else {
        console.error('拿不到popover实例');
      }
    },
    // 获取组织详情
    getDetail(list, id = 0) {
      this.detailId = id;
      this.list = list;
      this.loading = true;
      let params = {
        id: id,
        settlement_ids: list && list.map((item) => item.id).join(","),
      };
      this.$http
        .post("/admin/finance/showApplyPayment", params)
        .then((res) => {
          if (res.code == 1) {
            this.info = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset(done) {
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    oaSuccess() {
      this.toggle(false);
      this.$emit("refresh");
    },
    hadlePreview(row) {
      console.log(row)
      this.fileUrl = row.url;
      if(this.fileType == 5) {
        let dom = this.$refs.fileView;
        dom.toggle(true);
        dom.getDetail(row);
        dom = null;
      }
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let dom = this.$refs.inputOaDialogRef;
          dom.toggle(true);
          dom.getDetail(this.list, this.info);
        } else {
          return false;
        }
      });
    },
  },
};
</script>
